export enum SupervisionPercentageFrom {
    group = 'group',
    service = 'service',
}
